
import { NOT_FOUND } from 'redux-first-router'
import * as Routes from './index'; //TODO: Migrate routes here & add namespace.

export const goToPage = (page, payload) => {
  //TODO check for valid route namespace
  return (dispatch) => {
    dispatch({
      type: page,
      payload
    });
  }
};

export const goToUserManagement = (tab) => {
  return (dispatch) => {
    dispatch({
      type: Routes.ROUTE_USER_MANAGEMENT,
      payload: { tab }
    });
  }
};

export const goToManageConnections = () => {
  return (dispatch) => {
    dispatch({
      type: Routes.ROUTE_MANAGE_CONNECTIONS
    });
  }
};

export const redirectToNotFound = () => {
  return (dispatch) => {
    dispatch({ type: NOT_FOUND });
  }
};

export const redirectToNoAdminPermissions = () => {
  return (dispatch) => {
    dispatch({ type: Routes.ROUTE_NO_ADMIN_PERMISSION })
  }
}

export const redirectToHomePage = () => {
  return (dispatch) => {
    dispatch({ type: Routes.ROUTE_HOME })
  }
};

export const redirectToCampaignCreating = () => {
  return (dispatch) => {
    dispatch({
      type: Routes.ROUTE_CAMPAIGN
    })
  }
};

export const redirectToCampaignEdit = (campaignId, tab) => {
  return (dispatch) => {
    dispatch({
      type: Routes.ROUTE_CAMPAIGN_EDIT,
      payload: { campaignId, tab }
    })
  }
};

export const redirectToCampaignTabs = (advertiserId, campaignId, tab) => {
  return (dispatch) => {
    dispatch({
      type: Routes.ROUTE_CAMPAIGN_TABS,
      payload: { advertiserId, campaignId, tab }
    })
  }
};

export const goToCampaignPage = (advertiserId, campaignId, tab) => {
  return (dispatch) => {
    dispatch({
      type: Routes.ROUTE_CAMPAIGN_TABS,
      payload: { advertiserId, campaignId, tab }
    })
  }
};

export const redirectToAdvertiserEdit = (advertiserId, tab) => {
  return (dispatch) => {
    dispatch({
      type: Routes.ROUTE_ADVERTISER_EDIT_TAB,
      payload: { advertiserId, tab }
    })
  }
};

export const redirectToAdvertiserTabs = (advertiserId, tab) => {
  return (dispatch) => {
    dispatch({
      type: Routes.ROUTE_ADVERTISER_TABS,
      payload: { advertiserId, tab }
    })
  }
};

export const redirectToPlayoutDataMapping = () => {
  return(dispatch) => {
    dispatch({type: Routes.ROUTE_PLAYOUT_DATA_MAPPING})
  }
};

export const goToPlayoutBrowseUpload = () => {
  return(dispatch) => {
    dispatch({
      type: Routes.ROUTE_PLAYOUT_LOADER
    })
  }
}

export const goToPlayoutUploadHistory = () => {
  return(dispatch) => {
    dispatch({
      type: Routes.ROUTE_PLAYOUT_UPLOADS
    })
  }
}

export const redirectToPlayoutError = (fileId) => {
  return(dispatch) =>{
    dispatch({
      type: Routes.ROUTE_PLAYOUT_ERROR_REPORT,
      payload: { fileId }
    })
  }
}

export const goToCreateReport = (advertiserId, campaignId, tab, step, reportId = 0) => {
  return(dispatch) => {
    dispatch({
      type: Routes.ROUTE_CREATE_REPORT,
      payload: { advertiserId, campaignId, tab, step, reportId }
    })
  }
};

export const redirectToCampaignErrorPage = (advertiserId, campaignId) => {
  return (dispatch) => {
    dispatch({
      type: Routes.ROUTE_CAMPAIGN_ERROR_PAGE,
      payload: { advertiserId, campaignId }
    })
  }
};